import * as React from 'react';

import { FormItem } from '../../../../components/Form';
import CountryTree from '../../../../components/Others/CountryTree';

export interface ICountriesSettingsColProps {
  user: GQL.IUser;
  selectedCountryIds: string[];
  onChange: Function;
}

export default class CountriesSettingsCol extends React.Component<ICountriesSettingsColProps> {

  public render() {
    const { selectedCountryIds } = this.props;

    return (
      <>
        <FormItem label={'Access to country'}>
          <CountryTree
            name={'selectedCountryIds'}
            value={selectedCountryIds}
            onChange={(e: any, countries: GQL.ICountry[]) => this.onChange('selectedCountryIds', e.target.value)}
          />
        </FormItem>
      </>
    );
  }

  private onChange(name: string, value: any) {
    this.props.onChange({
      target: {
        name,
        value
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Users/UserDetail/components/Countries.tsx